import React, { useRef, useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../components/coontact.css"; // ← typo fixed: contact.css

export default function Contact() {
  const formRef = useRef(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 700, once: false });
  }, []);

  /* dummy send – replace with emailjs / fetch later */
  const sendEmail = e => {
    e.preventDefault();
    const data = new FormData(formRef.current);
    const output = {};
    data.forEach((val, key) => (output[key] = val));
    console.log("Quote form submitted:", output);

    setStatus("SUCCESS");
    e.target.reset();
  };

  return (
    <div className="contact-page">
      <section className="contact-hero" data-aos="fade-up">
        <h1>Get in Touch</h1>
        <p>
          Need a quote or have questions? Fill out the form and we’ll respond
          within one business day.
        </p>
      </section>

      <section className="contact-section" data-aos="fade-up">
        {/* details card */}
        <div className="contact-details">
          <div className="detail">
            <i className="fas fa-phone" />
            <h3>Phone</h3>
            <p>+27&nbsp;82&nbsp;498&nbsp;9477</p>
          </div>
          <div className="detail">
            <i className="fas fa-envelope" />
            <h3>Email</h3>
            <p>info@mosikeelectrical.com</p>
          </div>
          <div className="detail">
            <i className="fas fa-map-marker-alt" />
            <h3>Address</h3>
            <p>59A Kirkness&nbsp;Rd, The Orchards X10&nbsp;0182</p>
          </div>
        </div>

        {/* quote form */}
        <form
          ref={formRef}
          onSubmit={sendEmail}
          className="quote-form"
          noValidate
        >
          <input
            type="text"
            name="user_name"
            placeholder="Full Name"
            required
          />
          <input
            type="email"
            name="user_email"
            placeholder="Email Address"
            required
          />
          <input
            type="tel"
            name="user_phone"
            placeholder="Phone Number"
            pattern="[0-9+ ]{7,}"
            required
          />

          <select name="service_type" required>
            <option value="">Select Service</option>
            <option>Electrical Wiring</option>
            <option>Lighting Installation</option>
            <option>Circuit Design</option>
            <option>Power Backup Systems</option>
            <option>Safety Inspection &amp; Compliance</option>
          </select>

          <textarea
            name="message"
            rows="6"
            placeholder="Project Details"
            required
          />

          <button type="submit" className="btn send-btn">
            Send Quote Request
          </button>

          {status === "SUCCESS" && (
            <p className="status-message success">
              Thank you! We’ll be in touch soon.
            </p>
          )}
        </form>
      </section>
    </div>
  );
}
